// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__Ehn7H","icon":"HeaderCartButton_icon__IQR1q","badge":"HeaderCartButton_badge__bJj6W","navlinks":"HeaderCartButton_navlinks__a2inQ"};